import { useState } from 'react';
import { Users } from 'lucide-react';
import Lpp from "./Hublang/Penagihan-2/Lpp";
import { Tunggakan } from "./Hublang/Penagihan/TTunggakan";
import { Perlunasan } from "./Hublang/Penagihan/Perlunasan";
import { Pembatalan } from "./Hublang/Penagihan/Pembatalan";
import { Rlpp } from "./Hublang/Penagihan-2/Rlpp";
import RekAirPelanggan from './Hublang/Penagihan-2/RekAirPelanggan';

export default function DashboardPenagihan2() {
  const [menuStatus, setMenuStatus] = useState("lpp");
  
  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Users className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Loket</h1>
                {/* <p className="text-gray-600">Kelola data karyawan dan informasi kontrak</p> */}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                <button 
                  onClick={() => setMenuStatus("lpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'lpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'lpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  LPP
                </button>

                <button 
                  onClick={() => setMenuStatus("rlpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  RLPP
                </button>

                <button
                  onClick={() => setMenuStatus("RekAirPelanggan")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'RekAirPelanggan' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'RekAirPelanggan' ? 'blue' : 'gray'}-200 transition-colors`}>
                  Rek Air Pelanggan
                </button>
              </div>
            </div>
          </div>

          { menuStatus == "lpp" && <Lpp />}
          { menuStatus == "rlpp" && <Rlpp />}
          { menuStatus == "RekAirPelanggan" && <RekAirPelanggan />}
        </div>
      </div>
    </>
  )
}
